import ConfirmationModal from '@/components/ui-kit/confirmation-modal';
import { Dialog } from '@/components/ui-kit/dialog';
import { useDeleteFolder, useGetAgentsByFolderId } from '@/modules/gpt-chats/hooks/use-kb';
import { useTranslation } from 'react-i18next';

import { useToast } from '@/hooks/use-toast';

export const FolderDropdownDelete = ({
  folder_id,
  open,
  onOpenChange,
}: {
  folder_id: string;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}) => {
  const { t } = useTranslation();
  const deleteFolder = useDeleteFolder();
  const { toast } = useToast();
  const { refetch: fetchAgents, isFetching: isAgentsFetching } = useGetAgentsByFolderId(
    { folder_id },
    false
  );

  const confirmHandler = async () => {
    const { data: agents } = await fetchAgents();

    if ((agents?.data?.total_count ?? 0) > 0) {
      toast.error({
        title: t('ERROR'),
        errors: `${t('FOLDER_ASSOCIATED_WITH_AGENTS')} ${agents?.data?.agents.map((agent) => agent.name).join(', ')}`,
      });
      return;
    }

    deleteFolder.mutate(
      { folder_id },
      {
        onSuccess: (res) => {
          if (res.success) {
            toast.success(t('FOLDER_DELETED_SUCCESSFULLY'), t('SUCCESS'));
          } else {
            toast.error({
              title: t('ERROR'),
              errors: t('FAILED_TO_DELETE_FOLDER'),
            });
          }
          onOpenChange?.(false);
        },
        onError: () => {
          toast.error({
            title: t('ERROR'),
            errors: t('SOMETHING_WENT_WRONG_WHILE_DELETING_FOLDER'),
          });
          onOpenChange?.(false);
        },
      }
    );
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <ConfirmationModal
        data={{
          dialogTitle: t('DELETE_FOLDER'),
          dialogSubtitle: t('ARE_YOU_SURE_YOU_WANT_TO_DELETE_FOLDER'),
        }}
        onConfirm={confirmHandler}
        onCancel={() => onOpenChange?.(false)}
        buttonState={{
          confirm: { disable: deleteFolder.isPending || isAgentsFetching },
        }}
      />
    </Dialog>
  );
};
